import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "buttonText", "dropdown"]

  connect() {
    this.updateButtonText()
  }

  toggle(event) {
    const checkbox = event.currentTarget

    // Handle "Worldwide" special case
    if (checkbox.dataset.territory === "WO") {
      if (checkbox.checked) {
        // If Worldwide is checked, uncheck all other territories
        this.checkboxTargets.forEach(cb => {
          if (cb.dataset.territory !== "WO") {
            cb.checked = false
          }
        })
      }
    } else {
      // If any specific territory is checked, uncheck Worldwide
      const worldwideCheckbox = this.checkboxTargets.find(cb => cb.dataset.territory === "WO")
      if (worldwideCheckbox) {
        worldwideCheckbox.checked = false
      }
    }

    this.updateButtonText()
  }

  updateButtonText() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)

    if (checkedBoxes.length === 0) {
      this.buttonTextTarget.textContent = "Select territories"
    } else if (checkedBoxes.length === 1) {
      const territoryName = checkedBoxes[0].dataset.territoryName
      this.buttonTextTarget.textContent = territoryName
    } else {
      this.buttonTextTarget.textContent = `${checkedBoxes.length} territories`
    }
  }

  apply() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)
    const territoryCodes = checkedBoxes.map(cb => cb.dataset.territory)

    // Build URL with current params plus territory codes
    const url = new URL(window.location.href)
    const currentParams = new URLSearchParams(url.search)

    // Remove existing territory params
    currentParams.delete('territories')
    currentParams.delete('territories[]')

    // Add selected territories as array
    if (territoryCodes.length > 0) {
      territoryCodes.forEach(code => {
        currentParams.append('territories[]', code)
      })
    }

    // Navigate to new URL
    window.location.href = `${url.pathname}?${currentParams.toString()}`
  }

  reset() {
    // Uncheck all territories
    this.checkboxTargets.forEach(cb => {
      cb.checked = false
    })

    // Check Worldwide by default
    const worldwideCheckbox = this.checkboxTargets.find(cb => cb.dataset.territory === "WO")
    if (worldwideCheckbox) {
      worldwideCheckbox.checked = true
    }

    this.updateButtonText()
    this.apply()
  }

  search(event) {
    const searchTerm = event.target.value.toLowerCase()
    const territoryItems = this.element.querySelectorAll('[data-territory-item]')

    territoryItems.forEach(item => {
      const territoryName = item.dataset.territoryName.toLowerCase()
      if (territoryName.includes(searchTerm)) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}
